import { skipToken, useQuery } from '@tanstack/react-query';

import { IUser } from '@/interfaces/IUser';
import api from '@/services/api';

const authenticateToBackend = (): Promise<{ data: { data: { user: IUser } } }> => api.get('/api/frontend/authenticate');

export const useAuthenticateToBackend = ({ enabled }: { enabled: boolean }) =>
  useQuery({
    queryKey: ['backend_authentication'],
    queryFn: enabled ? () => authenticateToBackend() : skipToken,
    select: data => data.data.data.user
  });
